<script setup lang="ts">
import type { HighlightBannerProps } from './highlight-banner';

withDefaults(defineProps<HighlightBannerProps>(), {
  spacing: 'default',
});
</script>

<template>
  <section
    class="border-primary-200 from-primary-50 to-primary-100 text-primary-950 relative overflow-hidden rounded-xl border bg-gradient-to-r p-5 shadow-sm"
    :class="spacing === 'compact' ? 'space-y-3' : 'space-y-4'"
  >
    <div
      class="bg-primary-300/35 pointer-events-none absolute -top-10 -right-10 h-32 w-32 rounded-full blur-2xl"
    ></div>
    <div
      class="bg-primary-200/35 pointer-events-none absolute -bottom-12 left-10 h-28 w-28 rounded-full blur-2xl"
    ></div>

    <span
      v-if="badge"
      class="bg-primary-100 text-primary-800 mb-2 inline-flex rounded-full px-3 py-1 text-xs font-semibold tracking-wide uppercase"
    >
      {{ badge }}
    </span>

    <slot />
  </section>
</template>
